import { Box, Flex } from '@chakra-ui/react';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';

export default function PublicDsrJoinRoomForm({ 
	handleCheckUserEmail, 
	userEmailInput,
	onChangeHandler, 
	showEmailInputError,
	isProcessing
 }) {

	return (
		<>
			<Flex fontSize='1em' color='brandDark.500' fontWeight='600' textAlign='center'>
				Join the Room
			</Flex>

			<Flex fontSize='0.875em' color='gray.500' textAlign='center'>
				Ask questions • Connect with people • Get insights
			</Flex>

			<Box w="100%" mt='2em' maxW='25em' align="center">
				<Box px='1em' mt='1em'>

					<Box mt='1em' w='100%' >
						<LaunchdeckFormInput
							name={'email'}
							onChange={onChangeHandler}
							value={userEmailInput}
							label="Your email"
							errorLogic={showEmailInputError}
							errorMessage="Please provide a valid email"
							textAlign='center'
							autoFocus={true}
							isRequired={true}
							isDisabled={isProcessing}
						/>
					</Box>
				</Box>
			</Box>

			<Flex mt='1em' px='1em' pb='1em' w='100%' maxW='25em'>
				<Flex justify='center' w='100%'>
					<LaunchdeckButton bg='brand.500' px='3em' color='gray.50' w='100%' label='Join Room' loadingLogic={isProcessing} onClick={() => handleCheckUserEmail()} />
				</Flex>
			</Flex>
		</>

	);
};


